import classNames from 'classnames'
import {colorCodes, noOperation} from 'definitions/constant'
import {SvgIcon} from './SvgIcon'

const textWhite = 'text-white'
export const AeroplaneIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-black',
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M34.689 5.91729C35.5544 3.81543 34.8894 2.52845 34.1799 1.81899C33.5698 1.2089 32.8172 0.900146 31.9459 0.900146C29.6822 0.900146 27.2092 3.03468 25.9373 4.30829L23.6618 6.58384L6.54239 2.91449C6.35982 2.8759 6.16982 2.9323 6.03772 3.06441L3.54989 5.55223C3.42075 5.68286 3.36286 5.8684 3.39997 6.0495C3.4356 6.23059 3.5588 6.38051 3.72802 6.45177L18.0031 12.3995C15.021 15.6073 11.4568 19.7145 9.7457 22.7101L4.04874 21.5716C3.86765 21.5359 3.68061 21.5923 3.54999 21.7215L1.06217 24.2093C0.927088 24.3444 0.870681 24.5403 0.915213 24.7259C0.95826 24.9114 1.09631 25.0628 1.2774 25.1222L8.47802 27.5224L10.8783 34.7231C10.9376 34.9042 11.089 35.0422 11.2746 35.0853C11.3162 35.0956 11.3592 35.1001 11.4023 35.1001C11.5477 35.1001 11.6873 35.0437 11.7911 34.9383L14.279 32.4505C14.4096 32.3198 14.466 32.1328 14.4289 31.9517L13.2904 26.2548C16.2829 24.5448 20.3918 20.9792 23.6009 17.9958L29.5487 32.2724C29.6199 32.4417 29.7698 32.5649 29.9509 32.6005C29.9866 32.6079 30.0222 32.6109 30.0578 32.6109C30.2018 32.6109 30.3428 32.5545 30.4467 32.4491L32.9345 29.9613C33.0681 29.8292 33.123 29.6392 33.0844 29.4566L29.4151 12.3357L31.6906 10.0601C32.6926 9.06263 34.0256 7.53077 34.6891 5.91737L34.689 5.91729ZM4.91105 5.74955L6.60471 4.05737L22.7323 7.51302L22.2053 8.03996C21.4869 8.75691 20.2504 10.0112 18.8076 11.5401L4.91105 5.74955ZM31.9446 29.3958L30.2525 31.0895L24.462 17.1914C25.9909 15.7485 27.2452 14.5106 27.9622 13.7936L28.4891 13.2667L31.9446 29.3958ZM27.1813 13.0144C24.882 15.3137 17.0239 23.0088 12.4104 25.483C12.1966 25.5987 12.0823 25.8392 12.1298 26.0767L13.2906 31.8793L11.643 33.5269L9.43865 26.9111C9.38373 26.7464 9.25458 26.6172 9.08982 26.5623L2.4725 24.358L4.12014 22.7089L9.92274 23.8697C10.1632 23.9187 10.4022 23.8029 10.5165 23.5891C12.9954 18.9683 20.6861 11.1145 22.9851 8.81815L26.7168 5.08643C28.6776 3.12708 30.5836 2.00338 31.9463 2.00338C32.5237 2.00338 32.9987 2.19783 33.401 2.59861C34.0986 3.29625 34.1848 4.24329 33.6697 5.49759C33.1991 6.64056 32.2462 7.94977 30.9132 9.28273L27.1813 13.0144Z"
      fill="white"
    />
  </svg>
)

export const ArrowIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = textWhite,
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="arrow-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 13"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M24.0303 7.03033C24.3232 6.73744 24.3232 6.26256 24.0303 5.96967L19.2574 1.1967C18.9645 0.903806 18.4896 0.903806 18.1967 1.1967C17.9038 1.48959 17.9038 1.96447 18.1967 2.25736L22.4393 6.5L18.1967 10.7426C17.9038 11.0355 17.9038 11.5104 18.1967 11.8033C18.4896 12.0962 18.9645 12.0962 19.2574 11.8033L24.0303 7.03033ZM0.5 7.25H23.5V5.75H0.5V7.25Z"
      className="fill-current"
    />
  </svg>
)

export const HeartIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = textWhite,
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="heart-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 9"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M4.50048 8.14592L0.969948 4.6048L0.969978 4.60477L0.966668 4.60157C0.641372 4.2871 0.395949 3.78759 0.29714 3.24261C0.19846 2.69833 0.251927 2.14204 0.482759 1.71341C0.603657 1.49323 1.05611 0.971872 1.71805 0.803679C2.34672 0.643938 3.24212 0.78521 4.31075 2.02284L4.50465 2.24741L4.69308 2.01823C5.20294 1.39811 5.68161 1.05677 6.10646 0.888917C6.52868 0.722106 6.91125 0.721143 7.24286 0.803933C7.57785 0.887566 7.86715 1.05855 8.09118 1.24232C8.3174 1.42789 8.46278 1.61462 8.51722 1.71348C8.74804 2.14239 8.80147 2.69867 8.70292 3.24284C8.60423 3.78779 8.35904 4.28721 8.03417 4.60169L8.03414 4.60166L8.03101 4.6048L4.50048 8.14592Z"
      stroke="#919699"
    />
  </svg>
)

export const MacIcon: SvgIcon = ({
  width = 13,
  height = 16,
  strokeColor = textWhite,
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="mac-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${width} ${height}`}
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M2.1478 5.3805C2.66063 4.80312 3.38284 4.42455 4.33742 4.36665C4.77857 4.39534 5.16389 4.52272 5.54204 4.66633C5.59138 4.68507 5.64248 4.70499 5.69502 4.72546C6.01452 4.84999 6.38692 4.99513 6.73662 5.02071L6.80716 5.02587L6.87636 5.01126C7.24852 4.9327 7.62991 4.79589 7.97222 4.6731C8.09295 4.62979 8.20882 4.58823 8.31771 4.55158C8.7646 4.40117 9.1582 4.3059 9.55314 4.33468C10.4222 4.40808 11.0795 4.70396 11.5645 5.21084C9.40945 6.97624 9.93713 10.1709 12.0389 11.4067C11.6918 12.2822 11.2748 13.0972 10.6947 13.7635L10.3056 14.1555C10.0022 14.4611 9.71184 14.5679 9.43231 14.5822C9.13445 14.5975 8.80289 14.5096 8.4313 14.3417L8.43132 14.3417L8.42431 14.3387C7.43975 13.912 6.50636 13.8837 5.46248 14.3391L5.46247 14.3391L5.45799 14.3411C4.9292 14.578 4.59744 14.6275 4.35442 14.5923C4.12335 14.5588 3.89591 14.4378 3.59673 14.1553C1.76402 12.1908 1.00325 9.73421 1.19583 7.77802C1.29206 6.80047 1.623 5.97134 2.1478 5.3805ZM7.4502 3.20296C7.36104 3.24202 7.27744 3.27158 7.20019 3.29303C7.33326 2.17088 8.14867 1.25818 9.14926 0.941284C9.07259 1.58834 8.74628 2.16151 8.31533 2.59506C8.04099 2.87106 7.73558 3.07794 7.4502 3.20296Z"
      fill="white"
      stroke="white"
    />
  </svg>
)

export const WindowIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = textWhite,
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="window-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M0.504425 6.24903L0.50048 2.65767L4.94917 2.05367L4.95107 6.22378L0.504425 6.24903ZM0.503958 7.79274L4.94671 7.82145L4.95008 11.9957L0.5042 11.3863L0.503958 7.79274ZM6.60685 6.20752V1.81697L12.8317 0.911266V6.15825L6.60685 6.20752ZM6.59767 7.86302L12.8332 7.87318L12.8318 13.0913L6.606 12.2153L6.59767 7.86302Z"
      fill="white"
      stroke="white"
    />
  </svg>
)

export const DownloadIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = textWhite,
  fillColor = 'none',
  classes,
  onClick,
  id = 'download-icon',
}) => (
  <svg
    data-cy="download-icon"
    width={width}
    height={height}
    fill={fillColor}
    onClick={onClick}
    id={id}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      id={id}
      d="M18.36 14.75L13.11 20.25L7.85999 14.75"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="fill-none"
    />
    <path
      id={id}
      d="M13.11 19.25V5.75"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      id={id}
      d="M13 0.8C6.27301 0.8 0.8 6.27301 0.8 13C0.8 19.727 6.27301 25.2 13 25.2C19.727 25.2 25.2 19.727 25.2 13C25.2 6.27301 19.727 0.8 13 0.8ZM13 23.876C7.00326 23.876 2.124 18.9967 2.124 13C2.124 7.00326 7.00326 2.124 13 2.124C18.9967 2.124 23.876 7.00326 23.876 13C23.876 18.9967 18.9967 23.876 13 23.876Z"
      strokeWidth={0.4}
      className="fill-current"
    />
  </svg>
)

export const DownloadLinkIcon: SvgIcon = ({
  width = 12,
  height = 14,
  strokeColor = 'text-dope-cyan-bright',
  fillColor = 'transparent',
  strokeWidth = 1.5,
  classes,
  onClick,
  id = 'download-icon',
}) => (
  <svg
    data-cy="download-icon"
    width={width}
    height={height}
    fill={fillColor}
    onClick={onClick}
    id={id}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 14"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      d="M1 9.08621V10.2241C1 11.4811 1.92631 12.5 3.06897 12.5H8.93103C10.0737 12.5 11 11.4811 11 10.2241V9.08621M6 8.7069V1.5M6 8.7069L3.75862 6.05172M6 8.7069L8.24138 6.05172"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const QuestionIcon: SvgIcon = ({
  width = 26,
  height = 26,
  strokeColor = textWhite,
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy="question-mark-icon"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M16.8 6.19961C15.8 5.39961 14.6 5.09961 13.3 5.09961C12.1 5.09961 10.9 5.49961 9.80005 6.29961C8.90005 6.89961 8.40005 7.89961 8.10005 8.99961L7.90005 9.99961L10.6 10.2996L10.8 9.59961C10.9 8.99961 11.3 8.49961 11.7 8.19961C12.1 7.89961 12.7 7.69961 13.3 7.69961C14 7.69961 14.6 7.89961 15 8.19961C15.4 8.49961 15.6 8.89961 15.6 9.49961C15.6 9.69961 15.5 9.89961 15.4 10.1996C15.3 10.3996 15 10.6996 14.3 11.1996C13.4 11.8996 12.8 12.4996 12.5 12.8996C12.2 13.3996 12 13.8996 11.9 14.5996C11.9 14.7996 11.9 14.9996 11.9 15.0996V15.9996H14.7L14.8 15.1996C14.8 15.0996 14.8 14.9996 14.8 14.8996V14.7996C14.9 14.4996 14.9 14.3996 15 14.2996C15.1 14.0996 15.4 13.7996 16.3 13.0996C17.2 12.3996 17.7 11.7996 18 11.2996C18.4 10.6996 18.5 10.0996 18.6 9.49961C18.4 7.99961 17.8 6.89961 16.8 6.19961Z"
      className="fill-current"
    />
    <path
      d="M13.2 16.9996C12.3 16.9996 11.5 17.7996 11.5 18.6996C11.5 19.5996 12.3 20.3996 13.2 20.3996C14.1 20.3996 14.9 19.5996 14.9 18.6996C14.9 17.7996 14.2 16.9996 13.2 16.9996Z"
      className="fill-current"
    />
    <path
      d="M13.2 0.599609C6.40005 0.599609 0.800049 6.19961 0.800049 12.9996C0.800049 19.7996 6.40005 25.3996 13.2 25.3996C20 25.3996 25.6 19.7996 25.6 12.9996C25.6 6.19961 20.1 0.599609 13.2 0.599609ZM23.9 12.9996C23.9 18.8996 19.1 23.6996 13.2 23.6996C7.30005 23.6996 2.50005 18.8996 2.50005 12.9996C2.50005 7.09961 7.30005 2.29961 13.2 2.29961C19.1 2.29961 23.9 7.09961 23.9 12.9996Z"
      className="fill-current"
    />
  </svg>
)

export const ChevronRightIcon: SvgIcon = ({
  width = 5,
  height = 8,
  strokeColor = textWhite,
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    onClick={onClick}
    data-cy="chevron-right-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5 8"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M0.75 0.75L4.25 4L0.75 7.25"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronBottomIcon: SvgIcon = ({
  width = 6,
  height = 5,
  strokeColor = colorCodes.gray1100,
  strokeWidth = 1.5,
  fillColor = 'none',
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 6 5"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    data-cy="chevron-right-icon"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M5.25 1.25L3 3.40385L0.75 1.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TriangleWarningIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-red-100',
  strokeWidth = 0,
  fillColor = '#000',
  classes,
  datacy = 'triangle-warning-icon',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84051 4.64506C9.49487 3.95504 8.51014 3.95486 8.16424 4.64475L4.21698 12.5175C3.90441 13.1409 4.35766 13.8752 5.05504 13.8752H12.9459C13.6432 13.8752 14.0964 13.1412 13.7842 12.5178L9.84051 4.64506ZM7.15856 4.14053C7.91954 2.62277 10.086 2.62316 10.8464 4.1412L14.79 12.014C15.477 13.3854 14.4798 15.0002 12.9459 15.0002H5.05504C3.52082 15.0002 2.52366 13.3848 3.2113 12.0133L7.15856 4.14053Z"
      className="fill-current"
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6.75C9.41421 6.75 9.75 7.08579 9.75 7.5V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V7.5C8.25 7.08579 8.58579 6.75 9 6.75Z"
      className="fill-current"
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12Z"
      className="fill-current"
    />
  </svg>
)

export const ToastCheckIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = '#00D37E',
  strokeWidth = 1,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 12.75L10.1837 13.6744C10.5275 14.407 11.5536 14.4492 11.9564 13.7473L14.25 9.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const ToastCloseIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-red-200',
  strokeWidth = 1,
  classes,
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 9.75L14.25 14.25"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 9.75L9.75 14.25"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ToastWarningIcon: SvgIcon = ({
  width = 24,
  height = 25,
  strokeColor = textWhite,
  strokeWidth = 1.5,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M4.75 12.5C4.75 8.49594 7.99594 5.25 12 5.25C16.0041 5.25 19.25 8.49594 19.25 12.5C19.25 16.5041 16.0041 19.75 12 19.75C7.99594 19.75 4.75 16.5041 4.75 12.5Z"
      stroke="#F7C839"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M15.25 12.5L8.75 12.5"
      stroke="#F7C839"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-green-100',
  strokeWidth = 1.5,
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M5.75 12.8665L8.33995 16.4138C9.15171 17.5256 10.8179 17.504 11.6006 16.3715L18.25 6.75"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CopyIconNew: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-dope-cyan-bright',
  strokeWidth = 1.5,
  classes = '',
  onClick = noOperation,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M6.5 15.25C5.5335 15.25 4.75 14.4665 4.75 13.5V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H13.5C14.4665 4.75 15.25 5.5335 15.25 6.5"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 10.75C8.75 9.64543 9.64543 8.75 10.75 8.75H17.25C18.3546 8.75 19.25 9.64543 19.25 10.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H10.75C9.64543 19.25 8.75 18.3546 8.75 17.25V10.75Z"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FileDownloadIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-dope-cyan-bright',
  strokeWidth = 1.5,
  classes = '',
}) => (
  <svg
    data-cy="file-download-icon"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M12.75 4.75H7.75C6.64543 4.75 5.75 5.64543 5.75 6.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25H8.25M12.75 4.75V8.25C12.75 9.35457 13.6454 10.25 14.75 10.25H18.25M12.75 4.75L18.25 10.25M18.25 10.25V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H15.75"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13.75V19.25"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 16.75L12 19.25L14.25 16.75"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
